module.exports = __webpack_public_path__ + "flyer_background_sparkler_3_090-ad05e954898a51b1091882d492a12502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_sparkler_3_090.jpg
// module id = 1689
// module chunks = 1